import React from "react";

export const PaymentMethod = () => {
    return (
        <div className="mt-10 border-t border-gray-200 pt-10">
            <h2 className="text-lg font-medium text-gray-900">Płatności</h2>
            <fieldset className="mt-4">
                <legend className="sr-only">Payment type</legend>
                <div className="space-y-4 sm:flex sm:items-center sm:space-x-10 sm:space-y-0">
                    <p className="text-sm font-medium text-gray-700">Płatności w naszym systemie są przetwarzane przez system PayU.</p>
                </div>
            </fieldset>
        </div>
    );
}

export default PaymentMethod;